import { useEffect, useState } from "react";
import RepAbonReportHeader from "./rep-abon-report-header";
import RepAbonReportTotal from "./rep-abon-report-total";
import dayjs from "dayjs";
import { serverFetch } from "../../../server";
import { strDate2Server } from "../../../extensions/utils";
import { message } from "antd";
import { isMobile } from "../../../extensions/design";
import { ExcelDataProvider } from "../rep-excel-data-provider";
import { useLocalStorageFilter } from "@/extensions/use-local-storage-filter";

const periodType = [
  { value: 0, label: 'Период продажи'},
  { value: 1, label: 'Период оплаты'}
];

const employeeType = [
  { value: 0, label: "Всe сотрудники"},
  { value: 1, label: "По менеджерам"},
  { value: 2, label: "По исполнителям"},
  { value: 3, label: "По пользователям"}
];

// Отчет о продаже абонементов, состоящий из шапки и общего отчета
const RepAbon = () => {
  const [filters, setFilters] = useLocalStorageFilter(
    'repAbonFilter',
    () => ({
      startDate: dayjs(),
      endDate: dayjs(),
      periodType: periodType[0].value,
      employeeType: employeeType[0].value,
      specificProductIds: [],
    }),
    (parsed) => {
      const { startDate, endDate } = (() => {
        const savedDateEnd = parsed.endDate ? dayjs(parsed.endDate) : null;
        const defaultDateFrom = dayjs();
        const defaultDateEnd = dayjs();
        if (savedDateEnd && dayjs().endOf('day').diff(savedDateEnd, 'day') > 1) {
          return { startDate: defaultDateFrom, endDate: dayjs().endOf('day') };
        } else if (savedDateEnd && savedDateEnd.isBefore(dayjs(), 'day')) {
          return { startDate: parsed.startDate ? dayjs(parsed.startDate) : defaultDateFrom, endDate: dayjs().endOf('day') };
        }
        return { startDate: parsed.startDate ? dayjs(parsed.startDate) : defaultDateFrom, endDate: savedDateEnd || defaultDateEnd };
      })();
      return {
        startDate: startDate,
        endDate: endDate,
        periodType: parsed.periodType ?? periodType[0].value,
        employeeType: parsed.employeeType ?? employeeType[0].value,
        specificProductIds: parsed.specificProductIds || []
      };
    },
    (filters) => ({
      startDate: filters.startDate?.format('YYYY-MM-DD'),
      endDate: filters.endDate?.format('YYYY-MM-DD'),
      periodType: filters.periodType,
      employeeType: filters.employeeType,
      specificProductIds: filters.specificProductIds || []
    }),
  );

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const onFilterChange = (value) => {
    setFilters({...filters, ...value})}
    
  const [data, setData] = useState([]);

  const getData = () => {
    setLoading(true);
    serverFetch("report/SaleAbons", {method: "GET", queryParams: {startDate: strDate2Server(filters.startDate), endDate: strDate2Server(filters.endDate), periodType: filters.periodType, 
      ...(filters.employeeType != null && { employeeType: filters.employeeType }),
      ...(filters.specificProductIds != null && { SpecificProductIds: filters.specificProductIds})}})
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

    const getProducts = () => {
    setLoading(true);
    serverFetch("product", {method: "GET", queryParams: { vids: [2, 3] }})
      .then(data => {
        setProducts(data);
        //console.log(data)
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

  useEffect(() => {
    getProducts();
    getData();
  }, []);

  useEffect(() => {
    if (isMobile) {
      getData();
    }
  }, [filters]);

  const onRefresh = () => {
    getData();
    setRefreshTrigger((prev) => prev + 1);
    //console.log(refreshTrigger)
  };

  return (
    <ExcelDataProvider>
      <RepAbonReportHeader filters={filters} onFilterChange={onFilterChange} periodType={periodType} employeeType={employeeType} products={products} loading={loading} onRefresh={onRefresh}/>
      <RepAbonReportTotal filters={filters} loading={loading} data={data} pnRefresh= {getData} refreshTrigger={refreshTrigger}/>
    </ExcelDataProvider>
  )
}

export default RepAbon;